import React, { useState } from "react";
import ContentLoader from "../../Pages/LoadingPage/ContentLoader";
import "./style.css";

function getInitials(first = "", last = "") {
  const f = (first || "").trim();
  const l = (last || "").trim();
  return `${f.charAt(0) || ""}${l.charAt(0) || ""}`.toUpperCase();
}

export default function ConfirmDeleteRelationshipModal({ open, contact, onClose, onConfirm }) {
  const [submitting, setSubmitting] = useState(false);
  if (!open) return null;
  const fullName = `${contact?.first_name ?? ""} ${contact?.last_name ?? ""}`.trim();
  const category = contact?.relationship_category || contact?.related_data?.relationship_category || "";
  const initials = getInitials(contact?.first_name, contact?.last_name);

  const handleConfirmClick = async () => {
    if (submitting) return;
    setSubmitting(true);
    try {
      await onConfirm?.();
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="confirm-delete-overlay" role="dialog" aria-modal="true">
      <div className="confirm-delete-modal">
        <div className="confirm-delete-header">
          <div className="confirm-delete-title">Delete Relationship</div>
          <button className="confirm-delete-close" onClick={onClose} aria-label="Close">×</button>
        </div>

        <div className="confirm-delete-body">
          <div className="confirm-delete-card">
            <div className="confirm-delete-avatar">{initials}</div>
            <div className="confirm-delete-meta">
              <div className="confirm-delete-name">{fullName}</div>
              {category ? <div className="confirm-delete-category">{category}</div> : null}
            </div>
          </div>

          <div className="confirm-delete-text">
            Are you sure you want to delete this relationship? You won't be able to get advice on this person anymore.
          </div>
        </div>

        <div className="confirm-delete-actions">
          <button className="confirm-delete-btn" disabled={submitting} onClick={handleConfirmClick}>Delete</button>
          <button className="confirm-cancel-btn" disabled={submitting} onClick={onClose}>Cancel</button>
        </div>

        {submitting && (
          <div className="confirm-delete-submit-overlay" aria-live="polite" aria-busy="true">
            <ContentLoader />
          </div>
        )}
      </div>
    </div>
  );
}
